import { filterDiffFunction } from './chunk-X6IVGVL4.mjs';

// src/helpers/factories/settingsDifferences/diffPrinterRulesFactory.ts
var PrinterRulesFieldLabels = /* @__PURE__ */ ((PrinterRulesFieldLabels2) => {
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["name"] = 0] = "name";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["order"] = 1] = "order";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["daysOfWeek"] = 2] = "daysOfWeek";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["startTime"] = 3] = "startTime";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["endTime"] = 4] = "endTime";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["orderType"] = 5] = "orderType";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["delete"] = 6] = "delete";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["serviceAreaId"] = 7] = "serviceAreaId";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["fromPrepStationId"] = 8] = "fromPrepStationId";
  PrinterRulesFieldLabels2[PrinterRulesFieldLabels2["toPrepStationId"] = 9] = "toPrepStationId";
  return PrinterRulesFieldLabels2;
})(PrinterRulesFieldLabels || {});
var returnLabel = (field) => {
  if (field in PrinterRulesFieldLabels) {
    return field;
  }
};
var diffPrinterRulesFactory = (diffArray) => {
  if (diffArray.length > 0) {
    const printerRules = generatePrinterRulesObj(diffArray);
    return printerRules;
  }
  return null;
};
var generatePrinterRulesObj = (diffArray) => {
  const printerRules = [];
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ field, diffLength }) => {
        if (diffLength !== 1 && diffLength !== 2) {
          return;
        }
        const id = diff.path[0];
        if (diff.kind === "E") {
          const customNewDiff = {
            field,
            label: returnLabel(field) || "",
            value: diff.rhs
          };
          if (!printerRules.find((row) => row.id === id)) {
            printerRules.push({
              id,
              label: String(id) || "",
              changes: [customNewDiff],
              action: "update"
            });
          } else {
            for (const [i, row] of printerRules.entries()) {
              if (row.id === id) {
                printerRules[i].changes = [...row.changes, customNewDiff];
                break;
              }
            }
          }
        } else if (diff.kind === "N") {
          const changes = [];
          for (const [key, val] of Object.entries(
            diff.rhs
          )) {
            changes.push({
              field: key,
              label: returnLabel(key) || "",
              value: val
            });
          }
          printerRules.push({
            id,
            label: returnLabel(String(id)) || "",
            changes,
            action: "add"
          });
        } else if (diff.kind === "D") {
          printerRules.push({
            id,
            label: returnLabel(String(id)) || "",
            changes: [],
            action: "remove"
          });
        }
      },
      returnLabel
    )
  );
  return printerRules;
};
var orderTypeText = (t, orderType) => {
  const text = {
    all: t("commonTexts.all"),
    ["dine in" /* DINE_IN */]: t(
      "settingsModule.registerModeSettings.general.orderTypes.dineIn"
    ),
    ["catering" /* CATERING */]: t(
      "settingsModule.registerModeSettings.general.orderTypes.catering"
    ),
    ["delivery" /* DELIVERY */]: t(
      "settingsModule.registerModeSettings.general.orderTypes.delivery"
    ),
    ["to_go" /* TO_GO */]: t(
      "settingsModule.registerModeSettings.general.orderTypes.toGo"
    )
  };
  return text[orderType];
};

export { diffPrinterRulesFactory, orderTypeText };
